// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BCBtUZ {
  display: flex;
  align-items: center;
  border-radius: var(--radius-pill);
  border: 1px solid var(--surface-primary-medium);
  background: var(--surface-primary-subtle);
  padding-left: var(--spacing-1);
  padding-right: var(--spacing-0-5);
  padding-top: var(--spacing-0-5);
  padding-bottom: var(--spacing-0-5);
  height: 24px;
  gap: var(--spacing-0-5);
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary-medium);
}

.vDsHpq {
  display: flex;
  align-items: center;
  user-select: none;
}

.eh8DMs {
  background: none;
  border: none;
  padding: 0;
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 0;
}

.eh8DMs img {
  width: 12px;
  height: 12px;
  filter: brightness(0) saturate(100%) invert(44%) sepia(92%) saturate(2686%) hue-rotate(6deg) brightness(76%)
    contrast(104%);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/AppliedFilterChip/AppliedFilterChip.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,+CAA+C;EAC/C,yCAAyC;EACzC,8BAA8B;EAC9B,iCAAiC;EACjC,+BAA+B;EAC/B,kCAAkC;EAClC,YAAY;EACZ,uBAAuB;EACvB,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;kBACgB;AAClB","sourcesContent":[".filterChip {\n  display: flex;\n  align-items: center;\n  border-radius: var(--radius-pill);\n  border: 1px solid var(--surface-primary-medium);\n  background: var(--surface-primary-subtle);\n  padding-left: var(--spacing-1);\n  padding-right: var(--spacing-0-5);\n  padding-top: var(--spacing-0-5);\n  padding-bottom: var(--spacing-0-5);\n  height: 24px;\n  gap: var(--spacing-0-5);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-primary-medium);\n}\n\n.filterChipText {\n  display: flex;\n  align-items: center;\n  user-select: none;\n}\n\n.filterChipCloseButton {\n  background: none;\n  border: none;\n  padding: 0;\n  width: 12px;\n  height: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin: 0;\n}\n\n.filterChipCloseButton img {\n  width: 12px;\n  height: 12px;\n  filter: brightness(0) saturate(100%) invert(44%) sepia(92%) saturate(2686%) hue-rotate(6deg) brightness(76%)\n    contrast(104%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterChip": `BCBtUZ`,
	"filterChipText": `vDsHpq`,
	"filterChipCloseButton": `eh8DMs`
};
module.exports = ___CSS_LOADER_EXPORT___;
